import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { environment } from "src/environments/environment";
import { Parent } from "../models/parent";
import { dateToDB, dateToView } from "../shared/utils";

@Injectable({
  providedIn: 'root'
})
export class ParentService {
  private readonly _baseUrl = `${environment.api}/parents`;

  constructor(private http: HttpClient) { }


  public all = async (): Promise<Parent[]> => {
    const parents = await firstValueFrom(this.http.get<Parent[]>(`${this._baseUrl}/all`));
    for (const parent of parents) {
      parent.kids.forEach(k => k.birthDate = dateToView(k.birthDate));
    }
    return parents;
  }

  public add = async (data: any): Promise<Parent> => {
    const parent = await firstValueFrom(this.http.post<Parent>(`${this._baseUrl}/add`, data));
    parent.kids.forEach(k => k.birthDate = dateToView(k.birthDate));
    return parent;
  }

  public update = async (data: any): Promise<Parent> => {
    const parent = await firstValueFrom(this.http.put<Parent>(`${this._baseUrl}/update`, data));
    parent.kids.forEach(k => k.birthDate = dateToView(k.birthDate));
    return parent;
  }
}
